import PaymentRow from '../../../shopping-basket/check-order/PaymentRow';
import {PaymentMethodType} from './LendTechPaySheetTypes';

interface IProps {
  isCreditPayEnabled: boolean;
  onSelect: (method: PaymentMethodType) => void;
}

const PaymentMethodStep = ({isCreditPayEnabled, onSelect}: IProps) => (
  <div className="flex flex-col w-full gap-8">
    <p className="w-full p-0 m-0 text-sm font-medium text-center text-gray-950">
      انتخاب نوع پرداخت
    </p>

    <div className="flex flex-col justify-between w-full gap-3">
      <PaymentRow
        title="پرداخت نقدی"
        description="پرداخت در درگاه بانکی یا کارت به کارت و انتقال شبا"
        value="cash-payment"
        checked={false}
        onChange={onSelect}
      />

      <PaymentRow
        title="پرداخت اعتباری"
        description="خرید با اعتبار بازگشتی"
        value="credit-payment"
        checked={false}
        onChange={onSelect}
        disabled={!isCreditPayEnabled}
      />
    </div>
  </div>
);

export default PaymentMethodStep;
